import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import HeadacheNote from './pages/HeadacheNote';
import HeadacheNoteTerms from './pages/HeadacheNoteTerms';
import HeadacheNotePrivacy from './pages/HeadacheNotePrivacy';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/headache-note" element={<HeadacheNote />} />
        <Route path="/headache-note/terms" element={<HeadacheNoteTerms />} />
        <Route path="/headache-note/privacy" element={<HeadacheNotePrivacy />} />
      </Routes>
    </div>
  );
}

export default App;
